import { useCallback, useLayoutEffect, useRef, useState } from "react";
import { FaBars, FaBell, FaShieldAlt } from "react-icons/fa";
import {
  Arrow,
  ButtonSideBar,
  Container,
  ContainerAbrirMenu,
  ContainerNomeUsuario,
  NavImage,
  NavItem,
  NavItemIcone,
} from "./estilo";
import { UsuarioMenu } from "./UsuarioMenu";
import Notificacoes from "./Notificacoes";
import { CodigoDetran } from "./CodigoDetran";
import { useCodigoDetran } from "./hooks/useCodigoDetran";
import { faChevronDown, faChevronUp, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getNome } from "_services/auth";
import imgNav from "_assets/images/logo_branco_navbar.png";

const ESPACO_ABAIXO_NAVBAR = 3;

interface Props {
  alterMiniNavbar(): void;
  activeMiniNavbar: boolean;
  aberto: boolean;
  setAberto(aberto: boolean): void;
  abertoCodigoDetran: boolean;
  setAbertoCodigoDetran(aberto: boolean): void;
}

function Navbar({
  alterMiniNavbar,
  activeMiniNavbar,
  aberto,
  setAberto,
  abertoCodigoDetran,
  setAbertoCodigoDetran,
}: Props) {
  const { liberado, ...codigoDetran } = useCodigoDetran(abertoCodigoDetran);

  const navRef = useRef<HTMLElement>(null);
  const [topoMenu, setTopoMenu] = useState<number>(0);

  const medirTopoMenu = useCallback(() => {
    if (!navRef.current) {
      return;
    }

    setTopoMenu(navRef.current.getBoundingClientRect().bottom + ESPACO_ABAIXO_NAVBAR);
  }, []);

  useLayoutEffect(() => {
    if (!abertoCodigoDetran) {
      return;
    }

    medirTopoMenu();

    window.addEventListener("resize", medirTopoMenu);
    window.addEventListener("scroll", medirTopoMenu, true);

    return () => {
      window.removeEventListener("resize", medirTopoMenu);
      window.removeEventListener("scroll", medirTopoMenu, true);
    };
  }, [abertoCodigoDetran, medirTopoMenu]);

  function alternarMenuCodigoDetran() {
    setAberto(false);
    setAbertoCodigoDetran(!abertoCodigoDetran);
  }

  function alternarMenuUsuario() {
    setAbertoCodigoDetran(false);
    setAberto(!aberto);
  }

  return (
    <Container>
      <nav className="navbar navbar-static-top" role="navigation" ref={navRef}>
        <div className="navbar-header">
          <ButtonSideBar onClick={alterMiniNavbar}>
            <FaBars style={{ cursor: "pointer" }} size={"20px"} />
            <NavImage alt="imagePerfil" src={imgNav} />
          </ButtonSideBar>
        </div>
        <ul className="nav navbar-top-links navbar-right d-flex justify-content-between">
          {liberado && (
            <NavItem
              onClick={alternarMenuCodigoDetran}
              title="Código de dois fatores do despachante"
            >
              <NavItemIcone>
                <FaShieldAlt />
              </NavItemIcone>
            </NavItem>
          )}
          <NavItem>
            <a href="/pages/processo/Notificacao_Processo.php" style={{ padding: 0, color: "#fff" }}>
              <FaBell />
            </a>
          </NavItem>
          <NavItem>
            <FontAwesomeIcon icon={faUserCircle} />
          </NavItem>
          <NavItem onClick={alternarMenuUsuario}>
            <ContainerNomeUsuario>
              {getNome()}
            </ContainerNomeUsuario>
            <ContainerAbrirMenu>
              {aberto ? (
                <Arrow icon={faChevronUp} />
              ) : (
                <Arrow icon={faChevronDown} />
              )}
            </ContainerAbrirMenu>
          </NavItem>
        </ul>
        {liberado && abertoCodigoDetran ? (
          <CodigoDetran
            aberto={abertoCodigoDetran}
            topo={topoMenu}
            {...codigoDetran}
          />
        ) : (
          <UsuarioMenu aberto={aberto} />
        )}
      </nav>
    </Container>
  );
}
export default Navbar;

